import React, { useContext } from "react";
import Can from "../can/Can";
import { AppContext } from "../../App";
import { telegramBot } from "../../rbac-consts";
import { default as ClientContainer } from "./client/TelegramChatsTabsContainer";

const TelegramChatsWrapper = () => {
  const { user } = useContext(AppContext);

  return (
    <Can
      role={user.roles}
      perform={telegramBot.USER}
      yes={() => <ClientContainer />}
    />
  );
};

export default TelegramChatsWrapper;